import React from 'react'
import { DatePicker as AntdComponent } from '@formily/antd-mobile'
import { createBehavior, createResource } from '@designable/core'
import { DnFC } from '@designable/react'
import { createFieldSchema } from '../Field'
import { AllSchemas } from '../../schemas'
import { AllLocales } from '../../locales'

export const DatePicker: DnFC<React.ComponentProps<typeof AntdComponent>> = AntdComponent

DatePicker.Behavior = createBehavior({
  name: 'DatePicker',
  extends: ['Field'],
  selector: (node) => node.props['x-component'] === 'DatePicker',
  designerProps: {
    propsSchema: createFieldSchema(AllSchemas.DatePicker),
  },
  designerLocales: {
    'zh-CN': {
      title: '日期选择',
      settings: {
        'x-component-props': {
          picker: '类型'
        },
      },
    }
  },
})

DatePicker.Resource = createResource({
  icon: 'DatePickerSource',
  elements: [
    {
      componentName: 'Field',
      props: {
        type: 'boolean',
        title: 'DatePicker',
        'x-decorator': 'FormItem',
        'x-component': 'DatePicker',
        'x-component-props': {
          placeholder: '请选择',
        },
      },
    },
  ],
})
